import { ApiSimpleComponent } from "@incendium/api";
import { personalisationService } from "Apis";
import { useGlobalSharedState } from "Hooks/useSharedState";

const fetch = async () => {
  const res =
    await personalisationService.personalisationServiceListSharedComponentBlocks({});
  return res.components || [];
};

export const useSharedComponentBlocks = () => {
  const { state, setState, loading, refetch, fetched } = useGlobalSharedState<
    ApiSimpleComponent[]
  >("sharedComponentBlocks", [], fetch);

  return {
    blocks: state,
    setBlocks: setState,
    loading,
    refetch,
    fetched,
  };
};

